import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const sparkCache = new Map();
const TTL_MS = 5 * 60_000;

/** Hourly closes (last 36h) per base symbol, fetched lazily for the symbols on screen. */
export function useSparklines(symbols, quote = "USDT") {
  const [, force] = useState(0);
  const quoteUp = (quote || "USDT").toUpperCase();
  const bases = symbols.filter((s) => s && String(s).toUpperCase() !== quoteUp);
  const key = `${quoteUp}:${bases.join(",")}`;

  useEffect(() => {
    let alive = true;
    const stale = bases.filter((s) => {
      const hit = sparkCache.get(`${s}/${quoteUp}`);
      return !hit || Date.now() - hit.at > TTL_MS;
    });
    if (!stale.length) return undefined;
    Promise.all(
      stale.map((s) =>
        api
          .get(`/api/spot/sparkline/${s}/${quoteUp}`, { params: { interval: "1h", limit: 36 } })
          .then(({ data }) => sparkCache.set(`${s}/${quoteUp}`, { at: Date.now(), closes: (data?.closes || []).filter(Number.isFinite) }))
          .catch(() => sparkCache.set(`${s}/${quoteUp}`, { at: Date.now(), closes: [] })),
      ),
    ).then(() => alive && force((n) => n + 1));
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return (s) => sparkCache.get(`${s}/${quoteUp}`)?.closes;
}
